import React, { useMemo } from 'react';
import { Link } from '../../Atoms/Link';

export type Props = {
  engineUsed?: string;
  resultName?: string;
  isAdmin?: boolean;
};

export const EngineAttribution = ({
  engineUsed,
  resultName,
  isAdmin,
}: Props) => {
  const semgrepAttribution = useMemo(() => {
    if (engineUsed !== 'semgrep') {
      return undefined;
    }

    if (!resultName || resultName.startsWith('custom.')) {
      return undefined;
    }

    const searchParams = new URLSearchParams({
      q: resultName,
      utm_source: 'hackerone',
      utm_campaign: 'pullrequest',
    });
    return (
      <Link href={`https://semgrep.dev/r?${searchParams}`} target="_blank">
        Semgrep
      </Link>
    );
  }, [engineUsed, resultName]);

  const engineAttribution = useMemo(() => {
    if (!isAdmin || !engineUsed) {
      return undefined;
    }

    return <>{engineUsed}</>;
  }, [isAdmin, engineUsed]);

  const defaultAttribution = useMemo(() => {
    return <>PullRequest Automation</>;
  }, []);

  return semgrepAttribution ?? engineAttribution ?? defaultAttribution;
};
